<template>
    <div class="row">
        <div id="pagination" class="col-12 mt-2">
            <nav aria-label="Page navigation">
                <ul class="pagination">
                    <li class="page-item" @click="loadPage(1)" v-bind:class="isFirst()">
                        <a class="page-link" href="#!">First</a>
                    </li>
                    <li class="page-item" v-bind:class="isPreviousDisabled()"><a class="page-link" href="#!"
                            @click="loadPrevPage()">Previous</a></li>
                    <li class="page-item" v-bind:class="isPageActive(n)" v-for="n in this.pages" @click="loadPage(n)" v-show="showTab(n)">
                        <a class="page-link" href="#!">{{ n }}</a>
                    </li>
                    <li class="page-item" v-bind:class="isNextDisabled()"><a class="page-link" href="#!"
                            @click="loadNextPage()">Next</a></li>
                    <li class="page-item" @click="loadLast()" v-bind:class="isLast()">
                        <a class="page-link" href="#!">Last</a>
                    </li>
                    
                </ul>
            </nav>
        </div>
        <div  class="col-12 mt-2">
            <p>Showing page {{page}} of {{pages}}</p>
        </div>
    </div>
</template>
    
<script>
export default {
    name: "paginator",
    props: {
        p_page: null,
        p_pages: Number,
        p_parent_component: String,
        p_callback: null,
        p_show: 3
    },
    data() {
        return {
            page: this.p_page ? this.p_page + 1 : 1,
            show: this.p_show ? this.p_show : 5,
            pages: this.p_pages ?? 1,
            callback: this.p_callback ? this.p_callback : 'reload'
        }
    },
    methods: {
        reload() { 
            let parent = this.getComponent(this.p_parent_component);
            parent[this.callback](this.page - 1);
        },
        isPreviousDisabled() {
            if (this.page === 1) {
                return 'disabled';
            }
        },
        isNextDisabled() {
            if (this.pages === this.page) {
                return 'disabled';
            }
        },
        isFirst() {
            if (this.page === 1) {
                return 'disabled';
            }
        },
        isLast() {
            if (this.pages === this.page) {
                return 'disabled';
            }
        },
        showTab(p) {
            
            let leftShow = 0;
            let rightShow = 0;
            
            if (this.page > 0) {
                if (this.page  >= this.show) {
                    leftShow = this.page - this.show;
                } 
            }

            if (this.page < (this.p_pages - this.show)) {
                rightShow = this.page + this.show;
            } else {
                rightShow = this.p_pages;
            }

            if (p >= leftShow && p <= rightShow) {
                return true;
            } else {
                return false;
            }
        },
        isPageActive(p) {
            if (p === this.page) {
                return 'active';
            }
        },
        loadPage(p) {
            this.page = p;
            this.reload();
        },
        loadLast() {
            this.page = this.pages;
            this.reload();
        },
        loadNextPage() {
            this.page++;
            this.reload();
        },
        loadPrevPage() {
            this.page--;
            this.reload();
        },
        getComponent(componentName) {
            let component = null
            let parent = this.$parent
            while (parent && !component) {
                if (parent.$options.name === componentName) {
                component = parent
                }
                parent = parent.$parent
            }
            return component
        }
    },
};
</script>